import { APP_CONFIG } from '@/constants/app';
import { ApiResponse, UpdatePreferencesData, User } from '@/types/auth.types';
import { tokenManager } from '@/utils/token-manager';
import axios from 'axios';

// Create axios instance for user service
const userApi = axios.create({
  baseURL: APP_CONFIG.api.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup automatic token refresh interceptors
tokenManager.setupInterceptors(userApi);

export const userService = {
  /**
   * Update user preferences
   */
  updatePreferences: async (
    preferences: UpdatePreferencesData
  ): Promise<ApiResponse<User>> => {
    const response = await userApi.put<ApiResponse<User>>(
      '/users/preferences',
      preferences
    );
    return response.data;
  },

  /**
   * Get user profile with all preferences
   */
  getProfile: async (): Promise<ApiResponse<User>> => {
    const response = await userApi.get<ApiResponse<User>>('/users/profile');
    return response.data;
  },
};
